import React, { useRef, useState } from 'react';
import { Input, Tag } from 'antd';
import './TagInput.scss';

const TagInput = ({ tags = [], onChange, size = 'large' }) => {
  const [inputValue, setInputValue] = useState('');
  const inputRef = useRef(null);

  const handleClose = (removedTag) => {
    const newTags = tags.filter((tag) => tag !== removedTag);
    onChange(newTags);
  };

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleInputConfirm = () => {
    if (inputValue && tags.indexOf(inputValue) === -1) {
      const newTags = [...tags, inputValue];
      onChange(newTags);
    }
    setInputValue('');
  };

  const handleKeyDown = (e) => {
    if (e.key === ' ') {
      e.preventDefault();
      handleInputConfirm();
    }
  };

  return (
    <div className="tags-input">
      {tags.map((tag) => {
        return (
          <Tag className="edit-tag" key={tag} closable={true} onClose={() => handleClose(tag)}>
            {tag}
          </Tag>
        );
      })}
      <Input
        ref={inputRef}
        type="text"
        size={size}
        className="tag-input"
        value={inputValue}
        onChange={handleInputChange}
        onBlur={handleInputConfirm}
        onPressEnter={handleInputConfirm}
        onKeyDown={handleKeyDown}
        placeholder="Type and press space"
      />
    </div>
  );
};

export default TagInput;
